<template>
  <q-page class="q-pa-md">
    <!-- DIALOG VER DETALLES DEL BIEN -->
    <q-dialog full-width v-model="dialogBien" persistent>
      <Bien></Bien>
    </q-dialog>

    <!-- DIALOG PARA IMAGENES -->
    <q-dialog v-model="dialogImagenes" persistent>
      <q-card style="background: #f8fcff; width: 700px; max-width: 80vw">
        <q-bar class="bg-primary text-white">
          <q-icon name="mdi-bank" />
          <div>Evidencia Fotografica</div>
          <q-space />
          <q-btn dense flat icon="close" v-close-popup>
            <q-tooltip>Close</q-tooltip>
          </q-btn>
        </q-bar>
        <q-card-section>
          <q-carousel animated v-model="slide" thumbnails infinite :fullscreen.sync="fullscreen">
            <q-carousel-slide v-for="(img, index) in imagenesBase64" :key="index" :name="index + 1"
              :img-src="img.base64" />

            <template v-slot:control>
              <q-carousel-control position="bottom-right" :offset="[18, 18]">
                <q-btn push round dense color="white" text-color="primary"
                  :icon="fullscreen ? 'fullscreen_exit' : 'fullscreen'" @click="fullscreen = !fullscreen" />
              </q-carousel-control>
            </template>
          </q-carousel>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-card class="q-pa-md  q-mt-md">
      <div class="row q-col-gutter-md ">
        <div class="col-12 q-px-xl q-ma-md">
          <q-select dense bg-color="white" outlined v-model="item" option-label="nombre_unidad" :options="data"
            label="Nombre de la Unidad" color="teal" options-selected-class="text-deep-orange" :loading="loading">
            <template v-slot:option="scope">
              <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                <q-item-section avatar>
                  <q-icon name="mdi-hospital-building" />
                </q-item-section>
                <q-item-section>
                  <q-item-label v-html="scope.opt.nombre_unidad" />
                  <q-item-label caption>{{
                    scope.opt.nombre_sede + ", " + scope.opt.nombre_tipo_unidad
                    }}</q-item-label>
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:after>
              <q-btn color="primary" icon="mdi-magnify" round @click="ConsultaBienes()" />
            </template>
          </q-select>
        </div>
      </div>
    </q-card>

    <q-scroll-area class="q-pt-md" style="height: 80%; ">
      <q-card borderd class="row justify-around q-col-gutter-md">
        <div class="col-auto" v-for="(item, i) in indicadores" :key="i">
          <q-card class="q-pa-sm no-shadow	">
            <q-card-section class="text-center">
              <div class="text-h6">{{ item.titulo }}</div>
              <div class="text-h6 text-primary">{{ item.total }}</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="flex flex-center">
              <q-knob readonly v-model="item.progress" show-value size="90px" :thickness="0.22" :color="item.color"
                track-color="green-1" class="text-green">
                <template v-if="item.titulo == 'Nuevos'">
                  + {{ item.progress }}%
                </template>
                <template v-else>
                  {{ item.progress }}%
                </template>
              </q-knob>
            </q-card-section>
          </q-card>
        </div>
      </q-card>

      <!-- <div class="row q-col-gutter-md  ">
        <div class="col-md-2 col-6">
          <q-card class="q-pa-sm  ">
            <q-card-section class="text-center">
              <div class="text-h6">Localizado</div>
              <div class="text-h6 text-primary">{{ total1 }}</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="flex flex-center">
              <q-knob readonly v-model="progressLabel1" show-value size="90px" :thickness="0.22" color="green"
                track-color="green-1" class="text-green" />
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-6">
          <q-card class="q-pa-sm  ">
            <q-card-section class="text-center">
              <div class="text-h6">Conciliado</div>
              <div class="text-h6 text-primary">{{ total2 }}</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="flex flex-center">
              <q-knob readonly v-model="progressLabel2" show-value size="90px" :thickness="0.22" color="green"
                track-color="green-2" class="text-green" />
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-6">
          <q-card class="q-pa-sm  ">
            <q-card-section class="text-center">
              <div class="text-h6">Etiquetado</div>
              <div class="text-h6 text-primary">{{ total3 }}</div>
            </q-card-section>

            <q-separator />

            <q-card-section class="flex flex-center">
              <q-knob readonly v-model="progressLabel3" show-value size="90px" :thickness="0.22" color="green"
                track-color="green-3" class="text-green" />
            </q-card-section>
          </q-card>
        </div>

        <div class="col-md-2 col-6">
          <q-card class="q-pa-sm  ">
            <q-card-section class="text-center">
              <div class="text-h6">No Identificado</div>
              <div class="text-h6 text-primary">{{ total4 }}</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="flex flex-center">
              <q-knob readonly v-model="progressLabel4" show-value size="90px" :thickness="0.22" color="green"
                track-color="green-4" class="text-green" />
            </q-card-section>
          </q-card>
        </div>
        <div class="col-md-2 col-6">
          <q-card class="q-pa-sm  ">
            <q-card-section class="text-center">
              <div class="text-h6">Total</div>
              <div class="text-h6 text-primary">{{ total5 }}</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="flex flex-center">
              <q-knob readonly v-model="progressLabel5" show-value size="90px" :thickness="0.22" color="green"
                track-color="green-4" class="text-green" />
            </q-card-section>
          </q-card>
        </div>
        <div class="col-md-2 col-6">
          <q-card class="q-pa-sm  ">
            <q-card-section class="text-center">
              <div class="text-h6">Nuevos</div>
              <div class="text-h6 text-primary">{{ total6 }}</div>
            </q-card-section>
            <q-separator />
            <q-card-section class="flex flex-center">
              <q-knob readonly v-model="progressLabel6" show-value size="90px" :thickness="0.22" color="green"
                track-color="green-4" class="text-green" />
            </q-card-section>
          </q-card>
        </div>
      </div> -->

      <q-card class="q-pa-md q-mt-md ">
        <div class="col-12 col-md-12 ">
          <q-card-section borderd>
            <q-table class="no-shadow" dense :loading="loadingDetalles" title="Treats" style="height: 100%"
              :filter="filterDetalles" :data="dataDetalles" :columns="columnsBienes" row-key="name">
              <template v-slot:loading>
                <q-inner-loading showing color="primary" />
              </template>
              <template v-slot:top>
                <div full-width class="row full-width q-pb-sm">
                  <div class="col-12 row">
                    <a class="text-h5">Bienes</a>
                    <q-space></q-space>
                    <q-btn class="q-ml-sm text-primary" label="Exportar Excel" color="primary" icon="mdi-file-excel"
                      @click="exportTable()">
                      <q-tooltip> Generar Excel </q-tooltip>
                    </q-btn>
                  </div>
                  <div class="col-12 q-mt-md">
                    <q-input dense filled v-model="filterDetalles" label="Buscar" />
                  </div>
                </div>
              </template>
              <template v-slot:body="props">
                <q-tr :props="props" :class="'clase-' + props.row.estatus_emp">
                  <q-td key="numero_emp" :props="props">{{
                    props.row.numero_emp
                    }}</q-td>
                  <q-td key="id_activo" :props="props">{{
                    props.row.id_activo
                    }}</q-td>
                  <q-td key="descripcion" :props="props">{{
                    props.row.descripcion
                    }}</q-td>
                  <q-td key="nom_fabricante" :props="props">{{
                    props.row.nom_fabricante
                    }}</q-td>
                  <q-td key="id_serie" :props="props">{{
                    props.row.id_serie
                    }}</q-td>
                  <q-td key="modelo" :props="props">{{
                    props.row.modelo
                    }}</q-td>
                  <q-td key="costo" :props="props">{{
                    props.row.costo
                    }}</q-td>
                  <q-td key="estatus_emp" :props="props">{{
                    props.row.estatus_emp
                    }}</q-td>
                  <q-td auto-width key="acciones">
                    <q-btn
                      v-if="props.row.estatus_emp == 'LOCALIZADO' || props.row.estatus_emp == 'CONCILIADO' || props.row.estatus_emp == 'ETIQUETADO'"
                      size="md" color="blue" rounded flat dense @click="verImagenesItem(props.row)"
                      icon="mdi-image-multiple">
                      <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                        content-style="font-size: 14px">Ver Imagenes</q-tooltip>
                    </q-btn>
                    <q-btn size="md" color="primary" rounded flat dense @click="verDetallesItem(props.row)"
                      icon="mdi-table-eye">
                      <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                        content-style="font-size: 14px">Ver Información</q-tooltip>
                    </q-btn>
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </q-card-section>
        </div>
      </q-card>
      <q-card class="q-pa-md q-mt-md ">
        <div class="col-12 col-md-12 ">
          <q-card-section borderd>
            <q-table dense class="no-shadow" :loading="loadingDetallesNuevos" title="Treats" style="height: 100%"
              :filter="filterDetallesNuevos" :data="dataDetallesNuevos" :columns="columnsBienesNuevos" row-key="name">
              <template v-slot:loading>
                <q-inner-loading showing color="primary" />
              </template>
              <template v-slot:top>
                <div full-width class="row full-width q-pb-sm">
                  <div class="col-12 row">
                    <a class="text-h5">Bienes Nuevos</a>
                    <q-space></q-space>
                    <q-btn class="q-ml-sm text-primary" label="Exportar Excel" color="primary" icon="mdi-file-excel"
                      @click="exportTableNuevos()">
                      <q-tooltip> Generar Excel </q-tooltip>
                    </q-btn>
                  </div>
                  <div class="col-12 q-mt-md">
                    <q-input dense filled v-model="filterDetallesNuevos" label="Buscar" />
                  </div>
                </div>
              </template>
              <template v-slot:body="props">
                <q-tr :props="props" :class="'clase-' + props.row.estatus_emp">
                  <q-td key="numero" :props="props">{{
                    props.row.numero
                    }}</q-td>
                  <q-td key="nombre_bien" :props="props">{{
                    props.row.nombre_bien
                    }}</q-td>
                  <q-td key="descripcion" :props="props">{{
                    props.row.descripcion
                    }}</q-td>
                  <q-td key="marca" :props="props">{{
                    props.row.marca
                    }}</q-td>
                  <q-td key="serie" :props="props">{{
                    props.row.serie
                    }}</q-td>
                  <q-td key="modelo" :props="props">{{
                    props.row.modelo
                    }}</q-td>
                  <q-td key="estado_con" :props="props">{{
                    props.row.estado_con
                    }}</q-td>
                  <q-td key="ubicacion" :props="props">{{
                    props.row.ubicacion
                    }}</q-td>
                  <q-td key="usuario" :props="props">{{
                    props.row.usuario
                    }}</q-td>
                  <q-td key="observacion" :props="props">{{
                    props.row.observacion
                    }}</q-td>
                  <q-td auto-width key="acciones">
                    <q-btn size="md" color="blue" rounded flat dense @click="verImagenesItemNuevos(props.row)"
                      icon="mdi-image-multiple">
                      <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                        content-style="font-size: 14px">Ver Imagenes</q-tooltip>
                    </q-btn>

                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </q-card-section>
        </div>
      </q-card>
    </q-scroll-area>
  </q-page>
</template>

<script>
import { format } from "date-fns";
import { date, QSpinnerFacebook } from "quasar";
import moment from "moment";
import axios from "axios";
import * as XLSX from "xlsx";
import Bien from "../components/Bien/Bien.vue";
import { exportFile } from "quasar";

function wrapCsvValue(val, formatFn) {
  let formatted = formatFn !== void 0 ? formatFn(val) : val;

  formatted =
    formatted === void 0 || formatted === null ? "" : String(formatted);

  formatted = formatted.split('"').join('""');
  return `"${formatted}"`;
}

export default {
  components: {
    Bien,
  },
  data() {
    return {
      imagenesBase64: [
      ],
      dialogImagenes: false,
      fullscreen: false,
      slide: 1,
      dialogDetalles: false,
      filterDetalles: "",
      dataDetalles: [],
      loadingDetalles: false,

      columnsBienes: [
        {
          name: "numero_emp",
          align: "center",
          label: "Número",
          field: "numero_emp",
          sortable: true,
          classes: " ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "id_activo",
          align: "center",
          label: "Número Nacional de Inventario",
          field: "id_activo",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "descripcion",
          align: "center",
          label: "Descripción del Bien",
          field: "descripcion",
          sortable: true,
          classes: " ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "nom_fabricante",
          align: "center",
          label: "Marca",
          field: "nom_fabricante",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "id_serie",
          align: "center",
          label: "ID Serie",
          field: "id_serie",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "modelo",
          align: "center",
          label: "Modelo",
          field: "modelo",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "costo",
          align: "center",
          label: "Inversión",
          field: "costo",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "estatus_emp",
          align: "center",
          label: "Estatus",
          field: "estatus_emp",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "acciones",
          align: "center",
          label: "Acciones",
          field: "acciones",
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
      ],
      item: {
        nombre_sede: "",
        nombre_tipo_unidad: "",
        nombre_unidad: "",
      },
      data: [],
      dialogBien: false,

      nombreArchivo: "",

      columnsBienesNuevos: [
        {
          name: "numero",
          align: "center",
          label: "Número",
          field: "numero",
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "nombre_bien",
          align: "center",
          label: "Nombre",
          field: "nombre_bien",
          sortable: true,
          classes: " ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "descripcion",
          align: "center",
          label: "Descripción",
          field: "descripcion",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "marca",
          align: "center",
          label: "Marca",
          field: "marca",
          sortable: true,
          classes: " ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "serie",
          align: "center",
          label: "Serie",
          field: "serie",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "modelo",
          align: "center",
          label: "Modelo",
          field: "modelo",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "estado_con",
          align: "center",
          label: "Estado",
          field: "estado_con",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "ubicacion",
          align: "center",
          label: "Ubicación",
          field: "ubicacion",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "usuario",
          align: "center",
          label: "Usuario",
          field: "usuario",
          sortable: true,
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "observacion",
          align: "center",
          label: "Observaciones",
          field: "observacion",
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "acciones",
          align: "center",
          label: "Acciones",
          field: "acciones",
          classes: "  ellipsis text-center",
          headerClasses: "bg-primary text-white text-center",
        },
      ],
      dataDetallesNuevos: [],
      loadingDetallesNuevos: false,
      filterDetallesNuevos: "",
      imagenesBase64: [],



    };
  },
  computed: {
    indicadores() {
      return [
        { titulo: "Localizado", total: this.total1, progress: this.progressLabel1, icon: "place", color: "green-3" },
        { titulo: "Conciliado", total: this.total2, progress: this.progressLabel2, icon: "done_all", color: "green-4" },
        { titulo: "Etiquetado", total: this.total3, progress: this.progressLabel3, icon: "label", color: "green-5" },
        { titulo: "No Identificado", total: this.total4, progress: this.progressLabel4, icon: "help", color: "green-6" },
        { titulo: "Bajas", total: this.total7, progress: this.progressLabel7, icon: "trending_down", color: "green-7" },
        { titulo: "Total", total: this.total5, progress: this.progressLabel5, icon: "functions", color: "green-8" },
        { titulo: "Nuevos", total: this.total6, progress: this.progressLabel6, icon: "new_releases", color: "green-9" }
      ]
    },

    total1() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "LOCALIZADO"
      ).length;
      return localizados;
    },
    total2() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "CONCILIADO"
      ).length;
      return localizados;
    },
    total3() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "ETIQUETADO"
      ).length;
      return localizados;
    },
    total4() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "NO IDENTIFICADO"
      ).length;
      return localizados;
    },

    total5() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.length;
      return localizados;
    },
    total6() {
      if (this.dataDetallesNuevos.length === 0) return 0;
      const localizados = this.dataDetallesNuevos.length;
      return localizados;
    },
    total7() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "BAJA"
      ).length;
      return localizados;
    },
    progress1() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "LOCALIZADO"
      ).length;
      return localizados / this.dataDetalles.length;
    },
    progress2() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "CONCILIADO"
      ).length;
      return localizados / this.dataDetalles.length;
    },
    progress3() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "ETIQUETADO"
      ).length;
      return localizados / this.dataDetalles.length;
    },
    progress4() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "NO IDENTIFICADO"
      ).length;
      return localizados / this.dataDetalles.length;
    },
    progress5() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.length;
      return localizados / this.dataDetalles.length;
    },
    progress6() {
      if (this.dataDetallesNuevos.length === 0) return 0;
      const localizados = this.dataDetallesNuevos.length;
      return localizados / this.dataDetalles.length;
    },
    progress7() {
      if (this.dataDetalles.length === 0) return 0;
      const localizados = this.dataDetalles.filter(
        (item) => item.estatus_emp === "BAJA"
      ).length;
      return localizados / this.dataDetalles.length;
    },
    progressLabel1() {
      console.log(this.progress1)
      return Number((this.progress1 * 100).toFixed(2));
    },
    progressLabel2() {
      console.log(this.progress2)

      return Number((this.progress2 * 100).toFixed(2));
    },
    progressLabel3() {
      console.log(this.progress3)

      return Number((this.progress3 * 100).toFixed(2));
    },
    progressLabel4() {
      console.log(this.progress4)

      return Number((this.progress4 * 100).toFixed(2));
    },

    progressLabel5() {
      console.log(this.progress5)

      return Number((this.progress5 * 100).toFixed(2));
    },
    progressLabel6() {
      console.log(this.progress6)

      return Number((this.progress6 * 100).toFixed(2));
    },
    progressLabel7() {
      console.log(this.progress7)
      return Number((this.progress7 * 100).toFixed(2));
    },
    usuarioStore() {
      return this.$store.state.usuario;
    },
  },
  created() {
    this.GetTablas();
  },
  methods: {
    async verImagenesItem(item) {
      console.log(item)
      this.$q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: "white",
        spinnerSize: 140,
        message: "Consultando Datos. Espere...",
        messageColor: "white",
      });

      let obj = {
        bd_estado: this.item.bd_estado,
        tabla_unidad: this.item.tabla_unidad,
      };

      try {
        let respuesa = await axios.post(
          "Configuracion/GetBienWebXid_imagenes/" + item._id,
          obj
        );
        console.log(respuesa);
        this.imagenesBase64 = respuesa.data
        this.dialogImagenes = true
        this.$q.loading.hide();
      } catch (error) {
        this.$q.loading.hide();
        console.log(error);
      }
    },

    async verImagenesItemNuevos(item) {
      console.log(item)
      this.$q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: "white",
        spinnerSize: 140,
        message: "Consultando Datos. Espere...",
        messageColor: "white",
      });

      let obj = {
        bd_estado: this.item.bd_estado,
        tabla_unidad: this.item.tabla_unidad,
      };

      try {
        let respuesa = await axios.post(
          "Configuracion/GetBienWebXid_imagenes_nuevos/" + item._id,
          obj
        );
        console.log(respuesa);
        this.imagenesBase64 = respuesa.data
        this.dialogImagenes = true
        this.$q.loading.hide();
      } catch (error) {
        this.$q.loading.hide();
        console.log(error);
      }
    },

    async verDetallesItem(item) {
      this.$q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: "white",
        spinnerSize: 140,
        message: "Consultando Datos. Espere...",
        messageColor: "white",
      });

      let obj = {
        bd_estado: this.item.bd_estado,
        tabla_unidad: this.item.tabla_unidad,
      };

      try {
        let respuesa = await axios.post(
          "Configuracion/GetBienWebXid/" + item._id,
          obj
        );
        console.log(respuesa);
        this.$q.loading.hide();
        this.$store.state.bienStore = { ...respuesa.data };
        this.dialogBien = true;
      } catch (error) {
        this.$q.loading.hide();
        console.log(error);
      }
    },

    async GetTablas() {
      this.loading = true;
      try {
        let respuesa = await axios.get(
          "Configuracion/GetTablas/" + this.usuarioStore.baseDatos +'/'+ this.usuarioStore._id + '/' + this.usuarioStore.rol
        );
        console.log(respuesa);
        this.loading = false;
        this.data = respuesa.data;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async ConsultaBienes() {
      console.log(this.item)
      if (this.usuarioStore.rol == 'Coordinador') {
        let respuesta = await this.ValidarPermisoSede()
        console.log(respuesta)
        if (!respuesta) {
          this.$q.notify({
            position: 'top-right',
            message: 'El usuario no cuenta con los permisos necesarios para ver esta información.',
            color: 'info',
            icon: 'warning'
          })
          return
        }
      }

      this.verDetalles();
      this.verDetallesNuevos();
    },
    async verDetalles() {
      this.nombreArchivo =
        this.usuarioStore.estado +
        "_" +
        this.item.nombre_sede +
        "_" +
        this.item.nombre_tipo_unidad +
        "_" +
        this.item.nombre_unidad;

      this.loadingDetalles = true;
      let obj = {
        bd_estado: this.item.bd_estado,
        tabla_unidad: this.item.tabla_unidad,
      };
      console.log(obj);
      try {
        let respuesa = await axios.post("Configuracion/GetBienesWeb/", obj);
        console.log(respuesa);
        this.loadingDetalles = false;
        this.dataDetalles = respuesa.data;
      } catch (error) {
        this.loadingDetalles = false;
        console.log(error);
      }
    },

    async verDetallesNuevos() {
      this.nombreArchivo =
        this.usuarioStore.estado +
        "_" +
        this.item.nombre_sede +
        "_" +
        this.item.nombre_tipo_unidad +
        "_" +
        this.item.nombre_unidad;

      this.loadingDetallesNuevos = true;
      let obj = {
        bd_estado: this.item.bd_estado,
        tabla_unidad: this.item.tabla_unidad,
      };
      console.log(obj);
      try {
        let respuesa = await axios.post(
          "Configuracion/GetBienesNuevosLista/",
          obj
        );
        console.log(respuesa);
        this.loadingDetallesNuevos = false;
        this.dataDetallesNuevos = respuesa.data;
      } catch (error) {
        this.loadingDetallesNuevos = false;
        console.log(error);
      }
    },

    async ValidarPermisoSede() {
      try {
        let response = await axios.get('Login/ValidarPermisoSede/' + this.item.bd_estado + '/' + this.usuarioStore._id + '/' + this.item._id_unidad)
        return response.data
      } catch (error) {
        console.log(error)
      }
    },

    exportTable() {
      // naive encoding to csv format
      const content = [this.columnsBienes.map((col) => wrapCsvValue(col.label))]
        .concat(
          this.dataDetalles.map((row) =>
            this.columnsBienes
              .map((col) =>
                wrapCsvValue(
                  typeof col.field === "function"
                    ? col.field(row)
                    : row[col.field === void 0 ? col.name : col.field],

                  col.format
                )
              )
              .join(",")
          )
        )
        .join("\r\n");

      const status = exportFile(
        this.nombreArchivo + ".csv",
        content,
        "text/csv"
      );

      if (status !== true) {
        this.$q.notify({
          message: "Browser denied file download...",
          color: "negative",
          icon: "warning",
        });
      }
    },

    exportTableNuevos() {
      // naive encoding to csv format
      const content = [
        this.columnsBienesNuevos.map((col) => wrapCsvValue(col.label)),
      ]
        .concat(
          this.dataDetallesNuevos.map((row) =>
            this.columnsBienesNuevos
              .map((col) =>
                wrapCsvValue(
                  typeof col.field === "function"
                    ? col.field(row)
                    : row[col.field === void 0 ? col.name : col.field],

                  col.format
                )
              )
              .join(",")
          )
        )
        .join("\r\n");

      const status = exportFile(
        this.nombreArchivo + "_Nuevos.csv",
        content,
        "text/csv"
      );

      if (status !== true) {
        this.$q.notify({
          message: "Browser denied file download...",
          color: "negative",
          icon: "warning",
        });
      }
    },
  },
};
</script>
<style>
.clase-LOCALIZADO {
  background: rgb(219, 249, 226);
  z-index: -1;
}

.clase-NO {
  background: rgb(240, 240, 240);
  z-index: -1;
}

.clase-CONCILIADO {
  background: rgb(255, 234, 165);
  z-index: -1;
}

.clase-ETIQUETADO {
  background: rgb(219, 249, 226);
  z-index: -1;
}

.clase-BAJA {
  background: rgb(255, 162, 125);
  z-index: -1;
}
</style>